import React from 'react';
import { Pressable } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';
import { radius, useColors } from '../theme';
import { T } from './Text';

/** The small outlined action button used on item cards and offer rows. */
export function MiniButton({
  label,
  onPress,
  active = false,
  flex = true,
  style,
}: {
  label: string;
  onPress: () => void;
  active?: boolean;
  flex?: boolean;
  style?: StyleProp<ViewStyle>;
}) {
  const colors = useColors();
  return (
    <Pressable
      onPress={onPress}
      style={({ hovered, pressed }: any) => [
        {
          flex: flex ? 1 : undefined,
          borderWidth: 1,
          borderRadius: radius.sm,
          paddingVertical: 7,
          paddingHorizontal: 8,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: active ? colors.spice : 'transparent',
          borderColor: active ? colors.spice : hovered || pressed ? colors.gold : colors.line,
          opacity: pressed && !active ? 0.75 : 1,
        },
        style,
      ]}
    >
      {({ hovered }: any) => (
        <T
          size={11}
          weight={700}
          color={active ? '#FFFFFF' : hovered ? colors.gold : colors.textDim}
          numberOfLines={1}
        >
          {label}
        </T>
      )}
    </Pressable>
  );
}
